import React from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { FaIcon } from "components/FaIcon/FaIcon";

import "./LandingSteps.scss";

type LandingStepIconProps = {
    icon: IconDefinition;
};

export function LandingStepIcon({ icon }: LandingStepIconProps) {
    return (
        <div className="icon-container">
            <FaIcon icon={icon} />
        </div>
    );
}

type LandingStepsProps = {};

export function LandingSteps({
    children,
}: React.PropsWithChildren<LandingStepsProps>) {
    return (
        <div className="landing-steps">
            <div className="connector" />

            {children}
        </div>
    );
}
